import Vue from 'vue'
import Router from 'vue-router'
import adminRoutes from './adminRoutes'
import commonRoutes from './commonRoutes'
import routes from './routes'
import { globalBeforeGuard } from './globalGuards'

Vue.use(Router)

const router = new Router({
  scrollBehavior (to, from, savedPosition) {
    // 望みのポジションを返す
    return { x: 0, y: 0 }
  }
})
router.addRoutes(adminRoutes)
router.addRoutes(commonRoutes)
router.addRoutes(routes)
router.beforeEach(globalBeforeGuard)

export default router


// WEBPACK FOOTER //
// ./src/router/index.js